// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_bxslider.scss
// module id = 33
// module chunks = 0